import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DocumentService } from 'src/app/_services/document.services';

@Component({
  selector: 'app-share-document-link',
  templateUrl: './share-document-link.component.html',
  styleUrls: ['./share-document-link.component.scss'],
})
export class ShareDocumentLinkComponent implements OnInit {
  @Input() documentId: string;
  // @Output() openRedactDocumentTab = new EventEmitter<boolean>()
  @Output() close = new EventEmitter<boolean>();

  timeInHours: number = 1;
  message: string = null;
  documentUrl: string = null;

  constructor(
    private documentServices: DocumentService,
    public snackBar: MatSnackBar
  ) {}

  ngOnInit() {
    console.log('Doc Id ::', this.documentId);
  }

  checkValidity() {
    console.log(this.timeInHours);
    if (this.timeInHours > 14 * 24) {
      this.message = 'Time cannot exceed 14 days';
      // alert("Time cannot exceed 14 days")
      return true;
    }
    return false;
  }

  generateLinkHandler() {
    console.log('generate link');
    let validityCheck = this.checkValidity();
    if (validityCheck) {return};
    this.documentServices
      .generateShareLink(this.documentId, (this.timeInHours*60))
      .subscribe((resp: string) => {
        console.log(resp);
        this.documentUrl = resp.slice(5);
      });
  }

  copyToClipboard(textElement) {
    // let textElement = document.getElementById("documentLinkText")
    textElement.select();
    document.execCommand('copy');
    textElement.setSelectionRange(0, 0);
    // alert("Copied")
    this.snackBar.open('URL copied to clipboard', 'Close', { duration: 5000 });
  }

  // onClose() {
  //   this.openRedactDocumentTab.emit(false)
  // }

  onCancel() {
    this.message = null;
    this.documentUrl = null;
    this.close.emit(true);
  }
}
